// Central image registry (editorial illustration only — never represents real listings).
// Source: Unsplash (free licence). See /ASSET_MANIFEST.md for full attribution.
const q = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const qs = "?crop=entropy&cs=srgb&fm=jpg&q=80&w=900";

const base = "https://images.unsplash.com/";

const def = (id, alt) => ({
  url: `${base}${id}${q}`,
  thumb: `${base}${id}${qs}`,
  alt,
});

export const IMAGES = {
  // Landscape / atmosphere
  heroRidge: def("photo-1689676474552-3c5df0ec6b56", "Cloud drifting across forested Himalayan foothills in Uttarakhand"),
  valleyMist: def("photo-1689676474515-588063a0af3c", "Mist settling over a forested ridgeline in the Garhwal Himalaya"),
  himalayaRidge: def("photo-1742281413549-17ef65bb924a", "Rugged Himalayan ridgeline under a clear sky"),
  mountainRoad: def("photo-1723126622362-c29ec78235e9", "Winding road across a green hillside above a valley"),
  snowGolden: def("photo-1767286669935-e466c9ebb881", "Snow-capped Himalayan peaks lit by golden dawn light"),
  snowClouds: def("photo-1764140608148-80e010804af8", "Snow peaks rising above a sea of cloud at sunrise"),
  forestMist: def("photo-1502252430442-aac78f397426", "Aerial view of a pine forest wrapped in mist"),
  forestFog: def("photo-1487621167305-5d248087c724", "Silhouetted conifers in dense fog"),
  forestBlue: def("photo-1486707471592-8e7eb7e36f78", "Layered blue-grey forest ridges in fog"),
  terrace: def("photo-1626865002875-3dd5bebee4f2", "Terraced agricultural fields cut into a hillside"),
  valleyAerial: def("photo-1718106228194-b33c4e8f4ebf", "Aerial view of a river carving through a mountain valley"),

  // Locations
  dehradun: def("photo-1785938219835-0fa49418a460", "Lights of a Doon Valley town glowing beneath dark mountain silhouettes"),
  mussoorie: def("photo-1776527257206-c50d0eadfebb", "Hillside settlement and winding road on a Mussoorie ridge"),
  rishikesh: def("photo-1724864814923-548d7fd5f42e", "The Ganga flowing through forested gorges near Rishikesh"),
  haridwar: def("photo-1767653431683-9d8346bc18f3", "Sunrise over a hazy river valley in the Himalayan foothills"),
  nainital: def("photo-1622779100968-f38ad2954a0d", "Distant snow range seen across the Kumaon hills"),
  mukteshwar: def("photo-1713498236707-fe0f8661866b", "Valley and mountain layers in the Kumaon Himalaya"),
  almora: def("photo-1717820775574-bc200d22ce40", "Terraced village settlement spread across Kumaon hillsides"),
  ranikhet: def("photo-1773081834542-6a7fd01ba556", "Golden light on high Himalayan peaks above forested ridges"),

  // Architecture / material
  villaGreen: def("photo-1736386354031-e77794a50652", "Contemporary hillside house with a planted roof"),
  villaCliff: def("photo-1748741765391-33fffa0e548d", "Modern house cantilevered over a wooded slope"),
  villaStone: def("photo-1656977298653-69f660e13119", "Stone-and-timber house entrance framed by conifers"),
  stoneTexture: def("photo-1592551464477-c31b047602a0", "Dry-stacked slate stone wall detail"),
  timberTexture: def("photo-1626351339530-5056a140089b", "Layered timber cladding detail"),
  slateTexture: def("photo-1506968355081-0ed1cbd85ea5", "Riven slate masonry texture"),
};

export default IMAGES;
